// A preview build served against an API with no PostHog can name the flags
// it wants on, comma-separated, at dev time. Production builds set none, so
// every flag keeps its PostHog answer and its fallback.
const previewFlags = new Set(
  (import.meta.env.VITE_PREVIEW_FLAGS ?? "")
    .split(",")
    .map((key) => key.trim())
    .filter(Boolean),
);

export function previewFlagEnabled(key: string | undefined): boolean {
  return key !== undefined && previewFlags.has(key);
}
